/***
*
*   FEEDBACK
*   View and manage user feedback for your application.
*
**********/

import { Animate, Icon } from 'components/lib';
import { useFeedback } from './useFeedback';
import { FeedbackMetrics } from './FeedbackMetrics';
import { FeedbackFiltersPanel } from './FeedbackFilters';
import { FeedbackTable } from './FeedbackTable';
import { TEXT } from './constants';
import Style from './index.tailwind.js';

export function Feedback() {
  const {
    displayRows, metricsData, loading, metricsLoading,
    page, setPage, pageSize, setPageSize, totalPages,
    sortKey, sortDir, toggleSort,
    search, setSearch,
    filtersOpen, filtersRef,
    draftFilters, setDraftFilters,
    activeFilterCount,
    openFilters, closeFilters,
    applyFilters, clearFilters,
    deleteFeedback,
  } = useFeedback();

  return (
    <Animate>

      {/* Page header */}
      <div className={Style.header}>
        <h1 className={Style.title}>{TEXT.pageTitle}</h1>
        <p className={Style.subtitle}>{TEXT.pageSubtitle}</p>
      </div>

      {/* Metrics */}
      <FeedbackMetrics data={metricsData} loading={metricsLoading} />

      {/* Main content card */}
      <div className={Style.card}>

        {/* Search + Filters bar */}
        <div className={Style.toolbar}>

          {/* Search */}
          <div className={Style.searchWrap}>
            <span className={Style.searchIcon}>
              <Icon image="search" color="#b4b9c1" size={20} />
            </span>
            <input
              type="text"
              placeholder={TEXT.searchPlaceholder}
              value={search}
              onChange={e => setSearch(e.target.value)}
              className={Style.searchInput}
            />
          </div>

          {/* Filters button + panel */}
          <div ref={filtersRef} className={Style.filtersWrap}>
            <button
              onClick={() => filtersOpen ? closeFilters() : openFilters()}
              className={`${Style.filtersBtn} ${activeFilterCount > 0 ? Style.filtersBtnOn : Style.filtersBtnOff}`}
            >
              <Icon image="filter" color="currentColor" size={16} />
              {activeFilterCount > 0 ? `${TEXT.filtersBtn} · ${activeFilterCount}` : TEXT.filtersBtn}
            </button>

            {filtersOpen && (
              <FeedbackFiltersPanel
                draft={draftFilters}
                setDraft={setDraftFilters}
                onApply={applyFilters}
                onClear={clearFilters}
              />
            )}
          </div>
        </div>

        {/* Table */}
        <div className={Style.tableWrap}>
          <FeedbackTable
            rows={displayRows}
            loading={loading}
            sortKey={sortKey}
            sortDir={sortDir}
            onSort={toggleSort}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            totalPages={totalPages}
            onDelete={deleteFeedback}
          />
        </div>

      </div>

    </Animate>
  );
}
